import React from 'react';
import { Routes, Route, Navigate } from 'react-router-dom';

// Components
import Login from '../components/auth/login/Login';
import ProjectPage from '../pages/project/ProjectPage';
import Register from '../components/auth/register/Register';
import DashboardPage from '../pages/project/DashboardPage';

const PrivateRoute = ({ element }) => {
  const cookieExists = document.cookie.includes('PHPSESSID');
  if (!cookieExists) {
    return <Navigate to="/auth/login" />;
  }
  return element;
};

const PublicRoute = ({ element }) => {
  const cookieExists = document.cookie.includes('PHPSESSID');
  if (cookieExists) {
    return <Navigate to="/project" />;
  }
  return element;
};

const RouterApp = () => {
  return (
    <Routes>
      {/* Redirect از روت اصلی */}
      <Route path="/" element={<PublicRoute element={<Login />} />} />

      {/* صفحات عمومی */}
      <Route path="/auth/login" element={<PublicRoute element={<Login />} />} />
      <Route path="/auth/register" element={<PublicRoute element={<Register />} />} />

      {/* صفحه پروژه - با ساب‌مسیرها */}
      <Route path="/project" element={<PrivateRoute element={<ProjectPage setActiveTab={'projects'} />} />} />
      <Route path="/project/projects" element={<PrivateRoute element={<ProjectPage setActiveTab={'projects'} />} />} />
      <Route path="/project/add-project" element={<PrivateRoute element={<ProjectPage setActiveTab={'add-project'} />} />} />
      <Route path="/project/profile" element={<PrivateRoute element={<ProjectPage setActiveTab={'profile'} />} />} />
      <Route path="/project/subscription" element={<PrivateRoute element={<ProjectPage setActiveTab={'subscription'} />} />} />
      <Route path="/project/tutorial" element={<PrivateRoute element={<ProjectPage setActiveTab={'tutorial'} />} />} />
      <Route path="/project/:projectId/dashboard/:tab?" element={<PrivateRoute element={<DashboardPage />} />} />

      {/* در صورت آدرس اشتباه */}
      <Route path="*" element={<Navigate to="/auth/login" replace />} />
    </Routes>
  );
};

export default RouterApp;